<template>
    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="2.22484" y1="2.4165" x2="14.8042" y2="14.9959" stroke="#2F80ED" stroke-width="3" stroke-linecap="round"/>
        <line x1="14.8037" y1="2.3972" x2="2.36107" y2="14.8398" stroke="#2F80ED" stroke-width="3" stroke-linecap="round"/>
    </svg>
</template>
